<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="mrB10"/>
    <div class="comm_shut_wrap">
        <div class="inbox" style="flex:2;">
          <div class="comm_tree_wrap">

            <sui-tree
              :noDots="true"
              :wholeRow="true"
              :editable="false"
              v-bind="treeData"
              @item-click="onItem($event)"
              style="height:300px"
            />

          </div>
        </div>
        <div>
        
        </div>
        <div class="emptybox"></div>
        <div class="inbox" style="flex:3;">
         <div class="comm_view_wrap">
          <div class="row">
             <div class="col-xs-2">
              <sui-input-label :label="$t('MSG_TXT_UPP_DOM_CLS')"></sui-input-label>
             </div>
             <div class="col-xs-10">
             <div class="comm_label">{{this.upperDomainClassId}}</div>
             <div class="comp_spacing"></div>
             <div class="comm_label">{{this.upperDomainClassName}}</div>
             </div>
              
          </div>
          <div class="row">
             <div class="col-xs-2">
              <sui-input-label :label="$t('MSG_TXT_DOM_CLSF_NM')"></sui-input-label>
             </div>
             <div class="col-xs-10">
              <div class="comm_label">{{this.domainClassName}}</div>
             </div>
          </div>
          <div class="row">
             <div class="col-xs-2">
              <sui-input-label :label="$t('MSG_TXT_DOM_CLSF_ID')"></sui-input-label>
             </div>
             <div class="col-xs-10">
              <div class="comm_label">{{this.domainClassId}}</div>
            </div>
          </div>
         </div>
       </div>
      </div>
    </div>

      <div class="comm_btn_wrap mrR30">
        <sui-button type="button" class="comm_btn_border" @click="onCancel">{{$t('MSG_BTN_CANCEL')}}</sui-button>
        <sui-button type="button" class="comm_btn_solid" @click="onClickSelectWord" v-permission:read="'PGE_CMT_00007'">{{$t('MSG_BTN_SELT')}}</sui-button>
      </div>
    </div>

</template>
<script>
  export default {
    name: "PGE_CMT_00007_P02", // eslint-disable-line vue/name-property-casing
    props: {
    pageId : {
      type: String,
      default: 'PGE_CMT_00007'
    },
    biddingInformationParam: {
      type: Object,
      default() {
        return {};
      },
    },
  },
    data() {
      return {
        upperDomainClassId : '',
        upperDomainClassName:'',
        domainClassEnglishName : '',
        domainClassName: '',
        domainClassId: '',
        wordId: '',
        selectedWord: '',
        isOpen:false,
        clickedReadNode: {},
         codeEnable: false,
          showRetrievePopup : true,
        treeData: {
        data: [{
          id: '',
          parentId: '',
          folderYn: 'Y',
          level: 0,
          value: this.$t('MSG_TXT_ITGR_CLSF'),
          text: this.$t('MSG_TXT_ITGR_CLSF'),
          opened: true,
          wrdId : '' ,
          children: [],
        }],
      },
      };
    },
    computed: {
      dataFolder: function(){
        return this.item.children &&
        this.item.children.length
      }
    },
    watch: {},
    mounted() {
      const queryParams = {"domainClassificationLevel" : "1"};
          
      http.request(this.pageId, 'DTS_CMT_00048',{
        query: queryParams,
      }).then((res) => {
        this.setTreeData(res.data);
        //this.response= response.data.domainClassificationID;
      })
      .catch((error) => {
        console.log(error);
      });
    },
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    methods: {
    setTreeData(data) {
      const treeMap = {};
      const rootNode = {
        id: '0',
        parentId: null,
        level: 0,
        folderYn: 'Y',
        value: this.$t('MSG_TXT_ITGR_CLSF'),
        text: this.$t('MSG_TXT_ITGR_CLSF'),
        opened: true,
        children: [],
      };

      rootNode.children = utils.getMakeTreeData({
        id: 'domainClassificationID',
        parentId: 'upperDomainClassificationID',
        level: 'hierarchyLevel',
        value: 'domainClassificationName ',
        text: '{{domainClassificationName}} ({{domainClassificationID}})',
        wrdId: 'wordId',
      }, data, true);
       this.treeData = { data: [rootNode] };

    },
    onClickSelectWord() {
        console.log("TEST " + this.selectedWord.domainClassificationName) ;
        console.log("TEST " + this.selectedWord.domainClassificationID) ;
        this.$emit('upDomClsf',this.selectedWord);
        this.onPopupUpDomCancelClicked()
    },
    onItem(e) {
        this.selectedWord = e.data;
        if (e.data.domainClassificationLevel > 1 ){
          this.domainClassEnglishName = e.data.domainClassificationEnglishName;
          this.upperDomainClassId = e.data.upperDomainClassificationID;
          this.upperDomainClassName = e.data.upperDomainClassificationName;
          this.domainClassName = e.data.domainClassificationName;
          this.domainClassId = e.data.domainClassificationID;
          this.domainClassLevel = e.data.domainClassificationLevel;
          this.wordId = e.data.wrdId;
        }
        else if (e.data.domainClassificationLevel == 0 || e.data.domainClassificationLevel == undefined){

          console.log('test 1111'  + e.data.domainClassificationLevel);
          this.domainClassEnglishName = '';
          this.upperDomainClassId = 0;
          this.upperDomainClassName = ''; 
          this.domainClassName = this.$t('MSG_TXT_ITGR_CLSF');
          this.domainClassId = 0;
          this.domainClassLevel = e.data.domainClassificationLevel;
          this.wordId = '';

          this.selectedWord.domainClassificationName = this.domainClassName ; 
          this.selectedWord.domainClassificationID = this.domainClassId ; 
        }
        else {
          console.log('test '  + e.data.domainClassificationLevel);
          this.domainClassEnglishName = this.$t('MSG_TXT_ITGR_CLSF');
          this.upperDomainClassId = 0;
          this.upperDomainClassName = this.$t('MSG_TXT_ITGR_CLSF');
          this.domainClassName = e.data.domainClassificationName;
          this.domainClassId = e.data.domainClassificationID;
          this.domainClassLevel = e.data.domainClassificationLevel;
          this.wordId = e.data.wrdId;
        }
    },
    onPopupUpDomCancelClicked() {
      this.$emit('exit',true);
    },
    onCancel(){
      this.onPopupUpDomCancelClicked();
    },
    onPopupSaveClicked() {
      console.log('data  saved');
    },

    }
  };
</script>
<style scoped>
</style>
